/**
 * PopularCustomizations - Shows popular/trending customizations for quick selection
 */
import { memo } from 'react';
import { TrendingUp, Sparkles } from 'lucide-react';

const PopularCustomizations = memo(function PopularCustomizations({ 
  popularCustomizations, 
  onApplyCustomization 
}) {
  if (!popularCustomizations?.suggestion_label || !popularCustomizations?.popular_customizations?.length) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-950/30 dark:to-orange-950/30 rounded-xl p-3 border border-amber-200 dark:border-amber-800">
      <div className="flex items-center gap-2 mb-2">
        <TrendingUp className="w-4 h-4 text-amber-600 dark:text-amber-400" />
        <span className="text-sm font-medium text-amber-700 dark:text-amber-300">
          {popularCustomizations.suggestion_label}
        </span>
      </div>
      <div className="flex flex-wrap gap-2">
        {popularCustomizations.popular_customizations.slice(0, 4).map((pop, idx) => (
          <button
            key={idx}
            onClick={() => onApplyCustomization(pop)}
            className="inline-flex items-center gap-1 px-3 py-1.5 bg-white dark:bg-card rounded-full border border-amber-200 dark:border-amber-700 text-xs font-medium text-amber-700 dark:text-amber-300 hover:bg-amber-100 dark:hover:bg-amber-900/30 transition-colors"
            data-testid={`popular-customization-${pop.name.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <Sparkles className="w-3 h-3" />
            {pop.name}
            {pop.price > 0 && <span className="text-amber-500">+${pop.price.toFixed(2)}</span>}
          </button>
        ))}
      </div>
    </div>
  );
});

export default PopularCustomizations;
